import React from 'react'
import { ImproveAreaDisplayInfo } from '../../../../Types/AreaDisplayInfo/AreaDisplayInfo'
import ObjectiveCard from '../../../Improve/ObjectiveCard/ObjectiveCard'
import style from './ImproveCardCollection.module.css'
import Separator from '../../Separator/Separator'
import { useNavigate } from 'react-router-dom'

type ImproveCardCollectionProps = {
    archived: boolean,
    areas: ImproveAreaDisplayInfo[],
    toggleArchiveHandler?: (id: string) => void;
    disabledIds?: string[];
    hideExportButton?: boolean;
    onCardExport?: (id: string) => void;
}

const ImproveCardCollection = ({ 
    archived, 
    areas, 
    toggleArchiveHandler, 
    disabledIds,
    hideExportButton,
    onCardExport,
}: ImproveCardCollectionProps) => {
  const navigate = useNavigate();
  
  // Check if there are active filters (any disabled IDs means filters are applied)
  const hasActiveFilters = disabledIds && disabledIds.length > 0;

  const handleArchive = (item: ImproveAreaDisplayInfo) => {
    return toggleArchiveHandler ? () => toggleArchiveHandler(item.id) : undefined;
  };

  // Separate areas into matching and non-matching
  const matchingAreas = areas.filter(area => !disabledIds?.includes(area.id));
  const nonMatchingAreas = areas.filter(area => disabledIds?.includes(area.id));

  const renderArea = (item: ImproveAreaDisplayInfo, isDisabled: boolean) => {
    // Only apply special classes if there are active filters
    let cardClass = '';
    if (hasActiveFilters) {
      cardClass = isDisabled ? style.disabledCard : style.matchingCard;
    }
    
    return (
      <div key={item.id} className={cardClass}>
        <ObjectiveCard
          areaId={item.id}
          title={item.title}
          subtitle=""
          progress={[
            {
              label: 'Progress against completion of objectives',
              segments: item.objectiveSegments,
            },
            {
              label: 'Progress against completion of tasks',
              segments: item.taskSegments,
            },
            {
              label: 'Current impact',
              segments: item.impactSegments,
            },
          ]}
          archived={archived}
          onArchive={handleArchive(item)}
          onComplete={() => navigate(`/improve/${item.id}`)}
          canArchive={item.canArchive}
          canExport={item.canExport}
          canView={item.canView}
          hideExportButton={hideExportButton}
          onExport={onCardExport ? () => onCardExport(item.id) : undefined}
          dueDate={item.dueDate}
          roles={item.roles}
          groups={item.groups}
          organisations={item.organisations}
          departments={item.departments}
          participantCount={item.participantCount}
          productType={item.productType}
          status={item.status}
          impactSegments={item.impactSegments}
        />
      </div>
    );
  };

  return (
    <div className={style.cardsContainer}>
      {/* Render matching areas */}
      {matchingAreas.map(item => renderArea(item, false))}
      
      {/* Add separator if there are both matching and non-matching areas */}
      {hasActiveFilters && matchingAreas.length > 0 && nonMatchingAreas.length > 0 && (
        <Separator text="No matches found" />
      )}
      
      {/* Render non-matching areas */}
      {nonMatchingAreas.map(item => renderArea(item, true))}
    </div>
  )
}

export default ImproveCardCollection

